import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"
import { toast } from 'react-toastify';
import { ApiCall } from "../../EnvConfig/env_config";
import { useDispatch } from "react-redux";
import { setUser } from "../../features/authSlice";
import { Navigate } from 'react-router-dom';
import { useState } from "react";
import Loader from "../Common/Loader";

const CheckAuthenticationForPayment = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);

     const authEmail = localStorage.getItem('emailID')
    // const authLoginToken = localStorage.getItem('loginToken')
    const authLoginUserCode = localStorage.getItem('loginUserCode')
    const notAuthenticated = authEmail === null && authLoginUserCode === null;


    useEffect(() => {
        window?.google?.accounts?.id?.initialize({
            client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            callback: handleCredentialResponse,
        });

        window?.google?.accounts?.id?.renderButton(
            document.getElementById("googleButton"),
            { theme: "outline", size: "large" }
        );
    }, []);

    async function handleCredentialResponse(response) {
        console.log("Encoded JWT ID token: " + response.credential);
        const token = response.credential;

        // Split the token into its parts
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log("Decoded payload:", payload);
        console.log("User email:", payload.email);
        console.log("Token expiry time:", payload.exp);
        console.log("User Name:", payload.name);
        console.log("User Picture:", payload.picture);

        let request = {
            firstName: payload.given_name,
            lastName: payload.family_name,
            email: payload.email,
            google_auth_image: payload.picture,
            googl_auth_token: response.credential,
        }
        console.log(request, 'SignUpSignUpSignUp')
        setLoading(true)
        const ApiResponse = await ApiCall(`/api/Web/SignUp`, request);
        if (ApiResponse.status === 'SUCCESS') {
            const { loginUserCode, loginToken, userName, emailID, google_auth_image } = ApiResponse;
            dispatch(setUser(response))
            localStorage.setItem('loginUserCode', loginUserCode);
            localStorage.setItem('loginToken', loginToken);
            localStorage.setItem('userName', userName);
            localStorage.setItem('emailID', emailID);
            localStorage.setItem('google_auth_image', google_auth_image);
            setLoading(false)
            navigate("/checkout")
            window.location.reload()
        } else if (ApiResponse.status === 'ERROR') {
            toast.error(ApiResponse.message)
        }
    }


    if (!notAuthenticated) {
        return <Navigate to="/checkout" />;
    }

    return (
        <>
            <section>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-4 text-center">
                            <h4>You Have logged out!</h4>
                            <div id="googleButton" style={{ cursor: "pointer" }} className='border w-full my-3 pointer d-flex align-items-center justify-content-center py-1 bg-light br-12 gap-2' color="primary" variant="outlined" size="medium">
                                <img src="./assets/images/google.png" width={20} alt="" /> Login with Google
                            </div>
                            <p className='m-0'>or</p>
                            <div className="d-flex gap-2 align-items-center mt-4">
                                {/*    <span*/}
                                {/*className="mybtn secondary-bg text-dark w-100 pointer"*/}
                                {/*onClick={() => {*/}
                                {/*    localStorage.setItem("signAsGuest", true)*/}
                                {/*    navigate("/checkout")*/}
                                {/*}}*/}
                                {/*    >Sign as guest</span>*/}

                                <Link to='/login' className="mybtn secondary-bg text-dark w-100">Login Again</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {
                loading && <Loader />
            }
        </>

    )
}

export default CheckAuthenticationForPayment